import { RouteRecordRaw } from 'vue-router';
import { AppCoreEnums } from '@/core/shared/enums';
import { IRouteMeta, ResolveParams } from '@/core/models/routing';
import { AppPermissions } from '@/shared/permissions';

const ROUTE_EXPLORE_GPT_ROOT = 'explore-gpt-root';
const ROUTE_EXPLORE_GPT = 'explore-gpt';
const ROUTE_EXPLORE_GPT_DETAILS = 'explore-gpt-details';
const ROUTE_EXPLORE_GPT_OVERVIEW = 'explore-gpt-overview';

const exploreGptRoutes: RouteRecordRaw = {
  name: ROUTE_EXPLORE_GPT,
  path: ROUTE_EXPLORE_GPT,
  component: () => import('src/pages/chatbots/chatbots-page.vue'),
  meta: <IRouteMeta>{
    resolve: async (resolveParams: ResolveParams) => {
      const { useChatStore, useIndexesStore } = await import('@/stores');
      return Promise.all([
        useChatStore().loadChatbots(resolveParams),
        useChatStore().getChatProjects(),
        useChatStore().loadGPTModelsLite(),
        useIndexesStore().getIndexesLite(),
        useChatStore().loadUserChats(resolveParams),
      ]);
    },
    containerType: AppCoreEnums.ContainerType.CollapsibleTableContainer,
    permissions: { readPermission: AppPermissions.ChatbotRead },
  },
};

export { exploreGptRoutes, ROUTE_EXPLORE_GPT, ROUTE_EXPLORE_GPT_ROOT, ROUTE_EXPLORE_GPT_DETAILS, ROUTE_EXPLORE_GPT_OVERVIEW };
